import { Injectable } from '@angular/core';
import {
  CANONICAL_QR_POSTER_RENDERER_VERSION,
  QrPosterRenderDescriptorResponse,
} from '../models/qr-poster-render-descriptor.model';
import { AdminOrderItem } from './admin-sign-order.service';

@Injectable({ providedIn: 'root' })
export class SignOrderCanonicalRenderSnapshotAdapterService {
  toDescriptorResponse(item: AdminOrderItem): QrPosterRenderDescriptorResponse {
    const descriptor = item.canonicalRenderSnapshot?.descriptor;
    if (
      !descriptor
      || descriptor.rendererVersion !== CANONICAL_QR_POSTER_RENDERER_VERSION
      || descriptor.property.propertyId !== item.propertyId
      || !descriptor.qrDestination
    ) {
      throw new Error('Canonical QR poster snapshot is incomplete');
    }

    return {
      descriptor: JSON.parse(JSON.stringify(descriptor)),
    };
  }
}
